// @flow
import { SET_PENDING_STATUS, SET_SAVING_STATUS } from './constant';

export function setPendingStatus(componentName: string, isPending: boolean): SetPendingStatusActionType {
  return {
    type: SET_PENDING_STATUS,
    payload: { componentName, isPending },
  };
}

export function setCurrentSavingStatus(currentSavingStatus: string): SetSavingStatusActionType {
  return {
    type: SET_SAVING_STATUS,
    payload: { currentSavingStatus },
  };
}
